import React from "react";
import "./not-found.css";

const NotFound = ({message}) => {
    return (
        <section className="not-found-wrapper">
            <h1 className="not-found-head color-orange">{message}</h1>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                version="1.1"
                viewBox="0 0 1080 1080"
                xmlSpace="preserve"
                className="not-found"
            >
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#2A94F4"
                    d="M216.861 768.599c0-189.286 153.447-342.733 342.733-342.733s342.733 153.447 342.733 342.733"
                    opacity="0.07"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#2A94F4"
                    d="M224.499 770.302s79.44-189.446 107.912-171.925c28.472 17.521 95.727 171.925 95.727 171.925H224.499zM908.92 770.302s-72.622-181.361-98.65-164.587c-26.028 16.773-87.511 164.587-87.511 164.587H908.92z"
                    opacity="0.2"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#5E349D"
                    d="M574.925 773.586h-50.373a3.285 3.285 0 010-6.57h50.373a3.285 3.285 0 010 6.57z"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#D3D3D3"
                    d="M546.591 513.852a2.224 2.224 0 11-4.449 0 2.224 2.224 0 014.449 0z"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#D3D3D3"
                    d="M906.013 422.177H678.659c-7.83 0-14.236-6.406-14.236-14.236 0-7.83 6.406-14.236 14.236-14.236h227.355c7.83 0 14.236 6.406 14.236 14.236-.001 7.83-6.407 14.236-14.237 14.236zM402.144 384.162H264.576c-7.83 0-14.236-6.406-14.236-14.236 0-7.83 6.406-14.236 14.236-14.236h137.567c7.83 0 14.236 6.406 14.236 14.236 0 7.83-6.406 14.236-14.235 14.236zM845.123 369.927H707.556c-7.83 0-14.236-6.406-14.236-14.236 0-7.83 6.406-14.236 14.236-14.236h137.567c7.83 0 14.236 6.406 14.236 14.236 0 7.829-6.406 14.236-14.236 14.236zM278.466 436.413H140.899c-7.83 0-14.236-6.406-14.236-14.236 0-7.83 6.406-14.236 14.236-14.236h137.567c7.83 0 14.236 6.406 14.236 14.236 0 7.83-6.406 14.236-14.236 14.236zM869.087 540H731.519c-7.83 0-14.236-6.406-14.236-14.236 0-7.83 6.406-14.236 14.236-14.236h137.567c7.83 0 14.236 6.406 14.236 14.236.001 7.83-6.406 14.236-14.235 14.236zM387.179 554.236H212.134c-6.927 0-12.594-5.667-12.594-12.594v-3.283c0-6.927 5.667-12.595 12.594-12.595h175.045c6.927 0 12.595 5.668 12.595 12.595v3.283c0 6.926-5.668 12.594-12.595 12.594z"
                    opacity="0.4"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#D3D3D3"
                    d="M981.068 783.595c0 10.76-8.723 19.483-19.483 19.483H180.092c-10.76 0-19.483-8.723-19.483-19.483s8.723-19.483 19.483-19.483h781.494c10.76 0 19.482 8.723 19.482 19.483z"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#2A94F4"
                    d="M263.498 683.959s-15.523 54.903 22.55 56.774 32.149-36.304 25.534-51.27c-6.615-14.966 43.571-67.686-11.034-96.142-54.604-28.454-73.625 77.502-37.05 90.638zM198.031 705.404s-11.147 31.814 11.237 34.299c22.384 2.486 20.277-20.242 16.919-29.308-3.358-9.066 28.152-38.334-3.017-57.097s-46.231 43.031-25.139 52.106z"
                    opacity="0.4"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M211.073 676.203L211.44 767.016"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M221.062 697.781L211.209 709.943 200.768 699.078"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M283.103 626.509L284.525 764.112"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M300.345 644.196L283.447 659.779 268.141 645.477"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M300.252 673.124L283.354 688.708 268.048 674.405"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#2A94F4"
                    d="M891.105 683.959s-15.523 54.903 22.55 56.774c38.073 1.871 32.149-36.304 25.534-51.27-6.615-14.966 43.571-67.686-11.034-96.142-54.604-28.454-73.625 77.502-37.05 90.638zM825.638 705.404s-11.147 31.814 11.237 34.299c22.384 2.486 20.277-20.242 16.919-29.308s28.152-38.334-3.017-57.097-46.231 43.031-25.139 52.106z"
                    opacity="0.4"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M838.679 676.203L839.047 767.016"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M848.668 697.781L838.816 709.943 828.375 699.078"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M910.709 626.509L912.132 764.112"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M927.951 644.196L911.053 659.779 895.748 645.477"
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="#4D4D4D"
                    strokeMiterlimit="10"
                    d="M927.858 673.124L910.96 688.708 895.655 674.405"
                />
                <g xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill="#FAB9AF"
                        d="M587.396 638.962L577.079 566.468 549.245 562.648 534.768 638.438z"
                    />
                    <path
                        fill="#0E538C"
                        d="M565.882 751.291l.03 8.171a17.886 17.886 0 01-.671 4.917l-.71 2.517c-.583 2.066.97 4.117 3.117 4.109 5.565-.02 15.077-.005 17.529-.001.401.001.794-.27.829-.67.207-2.386-6.684-3.983-11.874-5.992-3.953-1.53-3.742-8.636-3.255-12.785.184-1.568-1.123-2.902-2.696-2.771a2.506 2.506 0 00-2.299 2.505zM527.632 748.999l-2.816 9.348c-.124.413-.31.805-.551 1.163l-1.996 2.964a3.375 3.375 0 001.815 5.114s4.024 1.416 8.173 2.779c4.247 1.395 9.588.229 9.588-.891 0-2.49-2.321-.514-6.209-3.114-1.303-.871-2.648-1.783-3.847-2.724-3.346-2.627-.424-9.277 1.624-13.023.737-1.347-.045-3.019-1.547-3.339l-.97-.207a2.8 2.8 0 00-3.264 1.93z"
                    />
                    <path
                        fill="#ff5252"
                        d="M556.39 639.663l30.843-2.589s3.106 22.448-4.689 63.085c-3.656 19.056-11.274 55.471-11.274 55.471-1.888.826-3.808 1.034-5.763.546 0 0-.579-16.063-.932-33.361-.339-16.59-.431-34.317-1.488-40.117-2.16-11.847-6.697-43.035-6.697-43.035z"
                    />
                    <path
                        d="M556.39 639.663l30.843-2.589s3.106 22.448-4.689 63.085c-3.656 19.056-11.274 55.471-11.274 55.471-1.888.826-3.808 1.034-5.763.546 0 0-.579-16.063-.932-33.361-.339-16.59-.431-34.317-1.488-40.117-2.16-11.847-6.697-43.035-6.697-43.035z"
                        opacity="0.07"
                    />
                    <path
                        fill="#ff5252"
                        d="M562.757 640.054c3.184 17.09 10.298 42.645-3.405 66.653-13.703 24.007-28.094 48.966-28.094 48.966-1.854.076-3.536-.597-5.099-1.783 0 0 2.403-10.884 5.876-23.592 3.973-14.538 9.006-31.639 7.572-40.555-2.687-16.71-5.774-38.964-4.838-49.772.935-10.806 26.313-8.903 27.988.083z"
                    />
                    <path
                        d="M562.757 640.054c3.184 17.09 10.298 42.645-3.405 66.653-13.703 24.007-28.094 48.966-28.094 48.966-1.854.076-3.536-.597-5.099-1.783 0 0 2.403-10.884 5.876-23.592 3.973-14.538 9.006-31.639 7.572-40.555-2.687-16.71-5.774-38.964-4.838-49.772.935-10.806 26.313-8.903 27.988.083z"
                        opacity="0.07"
                    />
                    <path
                        fill="#FFF"
                        d="M588.462 637.116l-11.382-70.647-27.834-3.82-14.959 74.599a2.564 2.564 0 002.032 3.03c5.182.982 17.682 3.034 31.671 3.034 10.443 0 16.312-2.031 18.982-3.316a2.713 2.713 0 001.49-2.88z"
                    />
                    <path
                        fill="#ff5252"
                        d="M557.941 567.048c0 5.089-.925 10.13-2.663 14.913-3.401 9.358-8.502 27.052-5.471 42.642 4.365 22.449 9.977 31.524 2.702 36.755-7.275 5.232-21.228-3.498-21.63-6.408-.403-2.91 2.715-38.658 6.249-54.145 3.534-15.487 13.431-37.752 13.431-37.752l4.193.448a3.568 3.568 0 013.189 3.547zM569.528 565.432s4.827 10.433 3.144 25.422c-1.684 14.989-5.585 60.633 8.055 67.525 4.319 2.183 14.183-7.483 14.183-11.068 0-3.586-3.292-15.589-6.411-26.502-3.119-10.913-10.637-54.234-10.637-54.234l-8.334-1.143z"
                    />
                    <path
                        fill="#FAB9AF"
                        d="M565.642 533.098c-6.212 0-8.53 4.422-8.648 12.602-.044 3.063 1.334 6.099 2.443 8.037.824 1.44 1.05 3.145.58 4.736l-1.364 4.617c-.927 4.283 1.107 6.632 4.109 7.485 1.487.422 3.27.095 4.568-.744 1.544-.998 1.671-3.144 1.384-4.961l-.352-1.316c-.475-1.773.553-3.685 2.347-4.077 4.783-1.046 5.468-6.032 6.75-13.776 1.335-8.072-5.605-12.603-11.817-12.603z"
                    />
                    <path
                        fill="#0E538C"
                        d="M565.413 528.551c-4.308 0-11.424 2.433-10.525 8.65l.794 4.397a3.95 3.95 0 003.56 3.223 1.394 1.394 0 002.74-.364c0-1.983 1.392-3.675 3.327-4.11 2.373-.533 4.908-.66 7.561.053 4.866 1.307 10.642-6.75 10.65-6.831 0 0-2.464 1.886-7.338.096-4.873-1.79-2.841-5.355-10.769-5.114z"
                    />
                    <path
                        fill="#FAB9AF"
                        d="M560.418 545.851c0 1.897-.706 3.434-2.532 3.434s-2.998-2.608-2.998-4.505c0-1.897 1.172-2.363 2.998-2.363s2.532 1.537 2.532 3.434z"
                    />
                    <path
                        fill="#ff5252"
                        d="M551.007 542.954s-.659 1.556-2.231 3.745c-.783 1.099-1.8 2.35-3.048 3.69a276.914 276.914 0 01-4.162 4.507c-1.528 1.638-3.214 3.375-4.909 5.279a64.215 64.215 0 00-4.968 6.211c-1.534 2.255-3.023 4.632-4.14 7.061-.545 1.211-1.017 2.435-1.289 3.572-.283 1.129-.363 2.192-.219 2.836.072.318.178.526.274.645.111.109.22.153.353.243.273.16.868.487 1.842.678l.546.136c.083.018.2.055.255.058l.158.007.629.048.735.032.703-.047a6.74 6.74 0 002.399-.785c1.366-.78 2.364-1.756 3.587-2.74 1.195-1.013 2.516-2.174 3.722-3.49 2.412-2.636 4.479-5.61 6.025-7.849l1.858-2.731c.456-.661.734-1.029.734-1.029l1.399.045s.239.39.621 1.151c.351.759.849 1.898 1.236 3.406.769 2.99 1.258 7.587-.604 13.037-.946 2.69-2.485 5.637-5.124 8.182a17.924 17.924 0 01-4.757 3.242c-1.827.861-3.889 1.406-5.984 1.625-4.211.421-8.454-.523-11.827-2.107-.891-.399-1.927-.899-2.895-1.53-.985-.674-1.979-1.443-2.85-2.511a11.219 11.219 0 01-2.012-3.608 11.984 11.984 0 01-.552-3.814c.059-2.403.692-4.347 1.403-6.067.723-1.723 1.594-3.212 2.497-4.614 1.808-2.791 3.764-5.209 5.74-7.436 1.953-2.239 3.89-4.303 5.708-6.264 1.837-1.942 3.599-3.739 5.305-5.311a74.988 74.988 0 014.811-4.102c1.463-1.182 2.843-2.092 4.049-2.757 2.406-1.338 4.087-1.72 4.087-1.72l.895 1.076zM599.345 643.368s-.934-1.232-1.702-3.467c-.408-1.115-.68-2.492-1.011-4.068a94.498 94.498 0 01-.888-5.316c-.284-1.951-.558-4.069-.964-6.29-.409-2.22-.962-4.541-1.525-6.929a154.412 154.412 0 00-1.967-7.266c-.342-1.229-.762-2.416-1.125-3.627-.404-1.183-.776-2.308-1.254-3.583a138.91 138.91 0 00-1.395-3.6c-.514-1.173-1.025-2.333-1.578-3.45-1.089-2.243-2.239-4.351-3.191-6.394-.973-2.039-1.795-4.006-2.579-5.888-.81-1.863-1.584-3.631-2.365-5.268-.784-1.632-1.529-3.168-2.254-4.536-.724-1.366-1.373-2.617-1.95-3.645l-1.345-2.481c-.319-.588-.48-.929-.48-.929l.692-.981s.373.048 1.054.19c.35.059.759.167 1.238.307.483.135 1.047.288 1.644.519a25.159 25.159 0 014.208 1.976c1.55.91 3.246 2.075 4.897 3.572a34.23 34.23 0 014.807 5.323c1.503 2.042 2.865 4.346 3.86 6.855 1.037 2.496 1.678 5.191 2.242 7.88l1.588 8.047c.248 1.267.498 2.711.734 4.081.191 1.362.378 2.727.508 4.057.295 2.669.489 5.27.685 7.779.221 2.504.353 4.924.567 7.203.215 2.279.494 4.419.698 6.402.223 1.98.336 3.805.393 5.426.037 1.624.072 3.038-.092 4.223-.276 2.363-.957 3.762-.957 3.762l-1.193.116z"
                    />
                    <path
                        fill="#FAB9AF"
                        d="M558.623 542.232c-1.669.849-3.25 1.884-3.946 2.152-.29.112-1.157.175-1.407.211-.734.105-1.887.152-2.454.63l-2.418 1.969c-1.153.971-2.496 1.15-3.467-.002-1.052-1.248-.464-2.713.897-3.613l1.669-1.406c1.09-.721 1.75-1.863 2.458-2.961 1.44-2.234 4.155-3.673 6.44-4.624 1.434-.597 3.342.262 5.819 1.544 1.217.63 2.916 1.97 1.227 2.329-1.415.301-5.291-1.393-7.633 2.064-.115.17-.379.627-.223.824.466.588 1.828-.38 2.681-.628 1.197-.349 2.065-.035 2.287.417.238.478-.738.487-1.93 1.094zM597.181 651.546c.037-1.873-.132-3.754-.04-4.494.038-.309.39-1.103.477-1.34.253-.697.755-1.736.6-2.462l-.598-3.06c-.314-1.474.161-2.744 1.635-3.057 1.596-.34 2.612.868 2.765 2.493l.454 2.135c.123 1.301.819 2.421 1.454 3.563 1.292 2.323 1.283 5.395 1.045 7.859-.149 1.546-1.805 2.825-4.102 4.406-1.129.777-3.111 1.644-2.633-.014.401-1.39 3.72-4.011 1.773-7.706-.096-.182-.375-.63-.622-.585-.739.134-.526 1.792-.709 2.661-.256 1.22-.942 1.838-1.445 1.822-.532-.019-.08-.884-.054-2.221z"
                    />
                    <path
                        fill="#E8948B"
                        d="M559.663 554.176s4.64 6.378 10.413 5.514c0 0-1.199.573-1.49 1.505-.001 0-5.484-.405-8.923-7.019z"
                    />
                </g>
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#ff5252"
                    className="not-found-question"
                    d="M564.661 504.723c.164-.666.61-.936 1.275-.773l4.815 1.183c.667.164.938.61.773 1.276l-1.157 4.713c-.164.666-.61.937-1.277.773l-4.815-1.183c-.665-.164-.936-.61-.771-1.276l1.157-4.713zm15.726-33.507c4.764 1.17 6.748 4.374 5.565 9.188l-2.479 10.092c-.138.563-.38.884-.878 1.142l-8.041 4.652c-.446.271-.688.591-.826 1.155l-.554 2.253c-.163.667-.609.937-1.276.773l-4.815-1.183c-.665-.164-.936-.61-.772-1.276l1.107-4.507c.126-.513.367-.833.813-1.104l8.666-5.205 1.736-7.07c.327-1.332-.266-2.237-1.547-2.552l-2.458-.604c-1.384-.34-2.225.214-2.552 1.546l-.981 3.996c-.126.512-.509.744-1.021.618l-5.328-1.309c-.563-.138-.744-.508-.618-1.021l1.334-5.43c1.183-4.815 4.373-6.747 9.188-5.564l5.737 1.41z"
                />
            </svg>
        </section>
    );
};

export default NotFound;
